export default "__VITE_ASSET__BGH0dojg__"